<template>
  <div class="d-flex">
    <v-text-field
      ref="textInput"
      class="mr-4"
      :label="$t('common.search')"
      prepend-icon="$edit"
      clearable
      single-line
      hide-details
      dense
      v-bind="$attrs"
      v-on="$listeners"
    />
    <v-btn
      fab
      x-small
      color="primary"
      :disabled="disableSearch"
      @click.stop="$emit('doSearch')"
    >
      <v-icon dark> $magnify </v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'BaseListSearch',

  props: {
    disableSearch: Boolean
  }
}
</script>

<style lang="scss" scoped></style>
